import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90e995aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "the_pulse" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row flex-lg-row-reverse" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 d-flex align-items-center" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "video" }, [
        /*#__PURE__*/_createElementVNode("iframe", {
          src: "https://www.youtube.com/embed/qnCoWkNo8Oc",
          title: "Falken Tyre",
          frameborder: "0",
          allowfullscreen: ""
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 d-flex align-items-center" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "text white" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "sub_title" }, "ON THE PULSE"),
        /*#__PURE__*/_createElementVNode("h2", { class: "title title_2 white" }, [
          /*#__PURE__*/_createTextVNode(" TAKING HIGH "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" PREMIUM PERFORMANCE "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" FROM RACETRACK "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" TO ROAD. ")
        ])
      ])
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}